export const AGENCY_PROPERTY_FORM_TOGGLE = 'agency_property_form/AGENCY_PROPERTY_FORM_TOGGLE'
export const AGENCY_PROPERTY_FORM_RESET = 'agency_property_form/AGENCY_PROPERTY_FORM_RESET'

export const SAVING_AGENCY_PROPERTY = 'agency_property_form/SAVING_AGENCY_PROPERTY'
export const SAVED_AGENCY_PROPERTY_SUCCESS = 'agency_property_form/SAVED_AGENCY_PROPERTY_SUCCESS'
export const SAVED_AGENCY_PROPERTY_FAILURE = 'agency_property_form/SAVED_AGENCY_PROPERTY_FAILURE'

export const DELETING_AGENCY_PROPERTY = 'agency_property_form/DELETING_AGENCY_PROPERTY'
export const DELETED_AGENCY_PROPERTY_SUCCESS = 'agency_property_form/DELETED_AGENCY_PROPERTY_SUCCESS'
export const DELETED_AGENCY_PROPERTY_FAILURE = 'agency_property_form/DELETED_AGENCY_PROPERTY_FAILURE'
export const AGENCY_PROPERTY_DELETE_RESET = 'agency_property_form/AGENCY_PROPERTY_DELETE_RESET'
